import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link } from "react-router-dom";
import { getPayRoll } from "../../../api/PayRollService";
import DownloadExcel from "../../master/DownloadExcel";

// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import * as XLSX from 'xlsx';

export default function PayrollHistoryPage() {
  const [filters, setFilters] = useState({ name: "", month: "" });
  const [loading, setLoading] = useState(false);
  const [payrollList, setPayrollList] = useState([
    
    {
      id: 1,
      staffName: "Aman Kumar",
      designation: "Teacher",
      salaryMonth: "2025-06",
      basic: 12000,
      hra: 4000,
      other: 1500,
      total: 17500,
    },
    {
      id: 2,
      staffName: "Sneha Sharma",
      designation: "Clerk",
      salaryMonth: "2025-06",
      basic: 10000,
      hra: 3000,
      other: 1000,
      total: 14000,
    },
    // add more records as needed
  ]);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
  const [staff, setStaff] = useState([]);
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [page, setPage] = useState(1);

  // Filter payroll list
  const filteredList = payrollList.filter((entry) => {
    const matchName =
      filters.name === "" ||
      entry.staffName.toLowerCase().includes(filters.name.toLowerCase());
    const matchMonth =
      filters.month === "" || entry.salaryMonth === filters.month;
    return matchName && matchMonth;
  });

  // Pagination calculation
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentRows = filteredList.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredList.length / rowsPerPage);

  const handleFilter = async (search) => {
    let addUrl = `&name=${search}&month=${month}&page=${page}`;
    const res = await getPayRoll(addUrl);
    if (res?.data?.status) {
      setStaff(res.data.data);
    }
  };
  let debounceTimer;
  useEffect(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      handleFilter(search, month);
    }, 300); // 300ms delay

    return () => clearTimeout(debounceTimer);
  }, [search, month]);

  const handleDownload = () => {
    const exportData = staff?.data?.map((item, index) => ({
      SN: index + 1,
      Name: item.staff?.name || "",
      FatherName: item.staff?.father_name || "",
      Phone: item.staff?.phone || "",
      type_id: item.staff?.type_id || "",
      present_days: item.present_days || "",
      leave_days: item.leave_days || "",
      month_days: item.month_days || "",
      PresentSalary: item.present_salary || "",
      paid_amount: item.paid_amount || "0",
      hra: item.hra || "",
      PendingAmount: item.pending_amount || "",
      Month: item.month || "",
      District: item.staff?.district || "",
      Village: item.staff?.village || ""
    })) || [];
  
    if (exportData.length === 0) {
      alert("No data available to export");
      return;
    }
  
    DownloadExcel(exportData, [], "Staff_Salary_Report", []);
  };
  
  


  return (
    <>
     {loading && (
          <div
            className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
            style={{ zIndex: 9999 }}
          >
            <div className="sk-chase sk-primary display-1">
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
            </div>
          </div>
        )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid py-4">
                {/* Filter & Actions */}
                <div className="card p-3 mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="text-primary"> Payroll</h3>

                    <div className="text-end">
                    <button
                          className="btn btn-success btn-sm"
                          onClick={handleDownload}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Export Excel"
                        >
                          <i className="bi bi-cloud-arrow-down ri-20px"></i>
                        </button>
                    </div>
                  </div>

                  <div className="row g-3 align-items-center">
                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search by Staff Name"
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="month"
                        className="form-control"
                        name="month"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Payroll Table */}
                <div className="card">
                  <div className="card-header  fw-bold">Payroll History</div>
                  <div className="table-responsive p-4">
                    <table className="table table-hover text-center m-0">
                      <thead className="table">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Month</th>
                          <th
                            data-bs-toggle="tooltip"
                            title="Total Day / Total Leave"
                          >
                            Work Days{" "}
                          </th>
                          <th data-bs-toggle="tooltip" title="Present / Absent">
                            P/A
                          </th>
                          <th>Basic Salary</th>
                          <th>Net Salary </th>
                          <th>Pending Salary </th>
                          <th>Paid Salary </th>
                          <th>HRA</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRows.length > 0 ? (
                          staff?.data?.map((entry, i) => (
                            <tr key={entry.id}>
                              <td>{indexOfFirst + i + 1}</td>
                              <td className="text-primary fw-bold">
                                {entry.staff.name}
                              </td>
                              <td>
                                {entry.month
                                  ? new Date(
                                      `${entry.month.split("-")[1]}-${
                                        entry.month.split("-")[0]
                                      }-01`
                                    ).toLocaleString("en-US", {
                                      month: "short",
                                      year: "numeric",
                                    })
                                  : ""}
                              </td>
                              <td>
                                {entry.month_days}/{entry.leave_days}
                              </td>
                              <td>
                                <span className="text-primary fw-bold">
                                  {entry.present_days}
                                </span>
                                /
                                <span className="text-danger fw-bold">
                                  {entry.month_days - entry.present_days}
                                </span>
                              </td>
                              <td>₹{entry.present_salary}</td>
                              <td>₹{entry.amount}</td>
                              <td>₹{entry.pending_amount}</td>
                              <td>₹{entry.paid_amount}</td>
                              <td>₹{entry.hra}</td>
                              <td>
                                <a className="btn btn-sm btn-primary" href="#">
                                  Pay
                                </a>
                              </td>{" "}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center text-muted">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination Controls */}
                  <nav aria-label="Page navigation" className="mt-10 ms-5">
                    <p>
                      Showing {staff?.from} to {staff?.to} of {staff?.total}{" "}
                      entries
                    </p>
                    <ul className="pagination pagination-sm">
                      {staff?.links?.map((btn, i) => (
                        <li
                          className={`page-item  ${btn?.active && "active"}  ${
                            btn?.url ? "" : "disabled"
                          } `}
                        >
                          <button
                            className="page-link waves-effect"
                            onClick={() => {
                              if (staff?.links?.length === i + 1) {
                                btn?.url && setPage(staff?.current_page + 1);
                              } else if (i === 0) {
                                btn?.url && setPage(staff?.current_page - 1);
                              } else {
                                setPage(btn.label);
                              }
                            }}
                          >
                            {staff?.links?.length == i + 1 ? (
                              <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                            ) : i == 0 ? (
                              <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                            ) : (
                              btn?.label
                            )}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>

                <Footer />
                <div className="content-backdrop fade"></div>
              </div>
            </div>
            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
          </div>
        </div>
      </div>
    </>
  );
}
